import { Language } from '../thi-translations';

export type CampaignTranslations = typeof campaignTranslations.ar;

export const campaignTranslations = {
  ar: {
    nav: {
      home: 'الرئيسية',
      features: 'المميزات',
      pricing: 'الأسعار',
      about: 'من نحن',
      contact: 'تواصل معنا',
    },
    hero: {
      label: 'منصة ذكية لإدارة أعمالك',
      titleBefore: 'منصة واحدة لفهم ',
      titleHighlight: 'وإدارة أعمالك',
      subtitle:
        'كل ما تحتاجه لإدارة فواتيرك، مصاريفك، تقاريرك وفهم أداء أعمالك بشكل أفضل، بمساعدة الذكاء الاصطناعي.',
      ctaPrimary: 'ابدأ مجاناً',
      ctaSecondary: 'شاهد كيف يعمل THI',
      trustNoCard: 'بدون بطاقة ائتمان',
      trustQuick: 'إعداد سريع',
      trustLang: 'يدعم العربية والإنجليزية والعبرية',
      aiAdvisorTitle: 'مستشار الأعمال AI',
      aiAdvisorInsight: 'مبيعات هذا الشهر أعلى بنسبة 32% عن الشهر الماضي — استمر!',
      extractedTitle: 'تم استخراج البيانات',
    },
    features: {
      title: 'كل أدوات إدارة أعمالك في مكان واحد',
      invoicing: 'الفواتير',
      invoicingDesc:
        'إصدار وإدارة فواتيرك ومستنداتك بسهولة واحترافية، ومتابعتها من مكان واحد.',
      expenses: 'المصاريف',
      expensesDesc:
        'أضف مصاريفك بسهولة، ونظّمها وتابعها لتعرف بشكل أفضل أين تذهب أموال عملك.',
      advisor: 'مستشار الأعمال الذكي',
      advisorDesc:
        'مساعد AI يفهم بيانات أعمالك ويساعدك على قراءة وضع مشروعك واتخاذ قرارات أفضل.',
      reports: 'التقارير والتحليلات',
      reportsDesc:
        'تقارير واضحة تجمع بيانات أعمالك وتساعدك على فهم الأداء واتخاذ قرارات مبنية على بيانات حقيقية.',
    },
    aiExpense: {
      title: 'إضافة المصاريف أصبحت أسهل بالذكاء الاصطناعي',
      text: 'كل ما عليك هو تصوير فاتورة المصروف، وسيقوم THI بتحليلها واستخراج بياناتها تلقائياً باستخدام الذكاء الاصطناعي.',
      steps: [
        'صوّر الفاتورة',
        'يقرأ THI البيانات',
        'يستخرج تفاصيل المصروف',
        'يصنف المصروف',
        'يضيفه إلى حساباتك',
      ],
      benefits: [
        'تصوير أي فاتورة أو إيصال',
        'استخراج البيانات تلقائياً',
        'تحليل الفاتورة بالذكاء الاصطناعي',
        'تصنيف المصروف تلقائياً',
        'تقليل الإدخال اليدوي',
        'توفير الوقت والجهد',
      ],
      cardTitle: 'تم استخراج البيانات',
      amount: 'المبلغ',
      date: 'التاريخ',
      category: 'التصنيف',
      merchant: 'التاجر',
      sampleAmount: '245.00',
      sampleDate: '15/04/2026',
      sampleCategory: 'مطاعم وأغذية',
      sampleMerchant: 'اسم المتجر',
    },
    aiAdvisor: {
      label: 'THI AI',
      title: 'مستشار أعمال يفهم أرقامك',
      text: 'مستشار الأعمال الذكي في THI لا يقدم لك إجابات عامة. يقوم بتحليل بيانات أعمالك الفعلية، بما فيها الإيرادات والمصاريف والفواتير، ليساعدك على فهم أداء مشروعك واتخاذ قرارات أفضل.',
      benefits: [
        'تحليل الأداء المالي',
        'فهم المصاريف والإيرادات',
        'اكتشاف التغيرات في أعمالك',
        'الإجابة عن أسئلتك حول بياناتك',
        'تقديم ملاحظات تساعدك على اتخاذ القرار',
        'رؤية أوضح لنمو أعمالك',
      ],
      cardTitle: 'مستشار الأعمال AI',
      cardIntro: 'بناءً على بياناتك، إليك بعض الملاحظات:',
      insights: [
        'مبيعات هذا الشهر أعلى بنسبة 32%',
        'المصاريف ارتفعت بنسبة 12%',
        'هناك ارتفاع ملحوظ في إحدى فئات المصاريف',
      ],
      inputPlaceholder: 'اسأل أي سؤال عن أعمالك...',
    },
    reports: {
      title: 'لا تجمع الأرقام فقط. افهم ماذا تعني.',
      text: 'يجمع THI بيانات الفواتير والمصاريف والدخل والتقارير في مكان واحد، ليعطيك صورة أوضح عن أداء عملك.',
      metrics: [
        'إجمالي المبيعات',
        'إجمالي المصاريف',
        'صافي الأداء',
        'المصاريف حسب التصنيف',
        'التغير مقارنة بالفترة السابقة',
        'اتجاه نمو العمل',
      ],
      supporting: 'كلما كانت بيانات عملك أوضح، أصبحت قراراتك أفضل.',
    },
    howItWorks: {
      title: 'ابدأ العمل في 3 خطوات بسيطة',
      steps: [
        {
          title: 'أنشئ حسابك',
          desc: 'سجل مجاناً خلال دقائق وابدأ بدون تعقيدات.',
        },
        {
          title: 'أضف بيانات أعمالك',
          desc: 'ابدأ بإضافة فواتيرك، مصاريفك ومعلومات عملك.',
        },
        {
          title: 'احصل على رؤية أوضح',
          desc: 'استخدم التقارير ومستشار الأعمال الذكي لفهم أعمالك بشكل أفضل.',
        },
      ],
    },
    pricing: {
      title: 'اختر الباقة المناسبة لك',
      subtitle: 'خطط مرنة تناسب احتياجات أعمالك في مختلف مراحل النمو.',
      compareTitle: 'مقارنة الباقات',
      compareSubtitle: 'قارن بين الخطط واختر ما يناسب احتياجات عملك.',
      featureCol: 'الميزة',
    },
    whyThi: {
      title: 'لماذا تختار THI؟',
      items: [
        { title: '3 واجهات لغوية', desc: 'العربية والإنجليزية والعبرية.' },
        {
          title: 'تصوير وتحليل المصاريف',
          desc: 'أضف مصاريفك بمجرد تصوير الفاتورة واترك للذكاء الاصطناعي عملية قراءة البيانات.',
        },
        {
          title: 'إدارة الفواتير',
          desc: 'أنشئ وأدر فواتيرك ومستنداتك من مكان واحد.',
        },
        {
          title: 'تقارير تساعدك على الفهم',
          desc: 'حوّل بيانات أعمالك إلى معلومات واضحة يمكنك استخدامها.',
        },
        {
          title: 'مستشار أعمال بالذكاء الاصطناعي',
          desc: 'مساعد ذكي يعتمد على بيانات أعمالك لمساعدتك على فهم ما يحدث داخل مشروعك.',
        },
        {
          title: 'منصة واحدة لأعمالك',
          desc: 'الفواتير والمصاريف والتقارير والتحليلات والذكاء الاصطناعي في مكان واحد.',
        },
      ],
    },
    languages: {
      title: 'استخدم THI باللغة التي تناسبك',
      text: 'غيّر اللغة بسهولة من داخل النظام.',
      ar: { title: 'العربية', desc: 'واجهة عربية كاملة واتجاه RTL' },
      en: { title: 'English', desc: 'Full English Interface' },
      he: { title: 'עברית', desc: 'ממשק מלא בעברית' },
    },
    faq: {
      title: 'الأسئلة الشائعة',
      items: [
        {
          q: 'هل أحتاج بطاقة ائتمان لبدء الاستخدام؟',
          a: 'لا، يمكنك إنشاء حساب والبدء بالتعرف على THI دون إدخال بطاقة ائتمان.',
        },
        {
          q: 'هل يدعم THI العربية والإنجليزية والعبرية؟',
          a: 'نعم، THI متوفر بثلاث واجهات: العربية والإنجليزية والعبرية.',
        },
        {
          q: 'كيف يعمل تحليل المصاريف بالذكاء الاصطناعي؟',
          a: 'يمكنك تصوير فاتورة أو إيصال المصروف، وسيقوم النظام بقراءة البيانات واستخراج المعلومات المهمة لمساعدتك على تسجيل المصروف بسهولة.',
        },
        {
          q: 'ما هو مستشار الأعمال الذكي؟',
          a: 'هو مساعد مدعوم بالذكاء الاصطناعي يستخدم بيانات أعمالك داخل THI ليساعدك على فهم المصاريف والإيرادات والأداء العام بشكل أفضل.',
        },
        {
          q: 'هل يمكنني تغيير الباقة لاحقاً؟',
          a: 'نعم، يمكن اختيار الباقة التي تناسب احتياجات العمل وتطويرها مع نمو الاستخدام.',
        },
        {
          q: 'هل يمكنني إدارة أكثر من شركة؟',
          a: 'يعتمد عدد الشركات المتاحة على الباقة التي تختارها.',
        },
        {
          q: 'هل الأسعار سنوية؟',
          a: 'نعم، الأسعار المعروضة حالياً هي أسعار سنوية.',
        },
        {
          q: 'ما المقصود برموز التحليل؟',
          a: 'هي الرصيد المستخدم لبعض عمليات التحليل والميزات المدعومة بالذكاء الاصطناعي داخل THI.',
        },
      ],
    },
    finalCta: {
      title: 'ابدأ بفهم أعمالك بشكل أفضل مع THI اليوم',
      text: 'انضم إلى THI وابدأ بإدارة فواتيرك، مصاريفك وبيانات أعمالك بطريقة أبسط وأكثر ذكاءً.',
      cta: 'ابدأ مجاناً الآن',
      trust: 'إعداد سريع • بدون بطاقة ائتمان • يدعم العربية والإنجليزية والعبرية',
    },
    stickyCta: 'ابدأ مجاناً',
  },
  en: {
    nav: {
      home: 'Home',
      features: 'Features',
      pricing: 'Pricing',
      about: 'About Us',
      contact: 'Contact Us',
    },
    hero: {
      label: 'Smart platform for your business',
      titleBefore: 'One platform to understand and ',
      titleHighlight: 'manage your business',
      subtitle:
        'Everything you need to manage invoices, expenses, reports, and understand performance—with AI at your side.',
      ctaPrimary: 'Start for Free',
      ctaSecondary: 'See how THI works',
      trustNoCard: 'No credit card required',
      trustQuick: 'Quick setup',
      trustLang: 'Arabic, English, and Hebrew',
      aiAdvisorTitle: 'AI Business Advisor',
      aiAdvisorInsight:
        'Sales this month are 32% higher than last month—keep it up!',
      extractedTitle: 'Data extracted',
    },
    features: {
      title: 'All your business tools in one place',
      invoicing: 'Invoices',
      invoicingDesc:
        'Issue and manage invoices and documents professionally from one place.',
      expenses: 'Expenses',
      expensesDesc:
        'Add and organize expenses to see where your business money goes.',
      advisor: 'Smart Business Advisor',
      advisorDesc:
        'An AI assistant that reads your data and helps you make better decisions.',
      reports: 'Reports & Analytics',
      reportsDesc:
        'Clear reports that help you understand performance with real data.',
    },
    aiExpense: {
      title: 'Adding expenses is easier with AI',
      text: 'Photograph an expense receipt and THI analyzes and extracts the data automatically.',
      steps: [
        'Photograph the receipt',
        'THI reads the data',
        'Expense details extracted',
        'Expense categorized',
        'Added to your accounts',
      ],
      benefits: [
        'Photograph any invoice or receipt',
        'Automatic data extraction',
        'AI invoice analysis',
        'Automatic categorization',
        'Less manual entry',
        'Save time and effort',
      ],
      cardTitle: 'Data extracted',
      amount: 'Amount',
      date: 'Date',
      category: 'Category',
      merchant: 'Merchant',
      sampleAmount: '245.00',
      sampleDate: '15/04/2026',
      sampleCategory: 'Restaurants & food',
      sampleMerchant: 'Store name',
    },
    aiAdvisor: {
      label: 'THI AI',
      title: 'A business advisor that knows your numbers',
      text: 'THI’s smart advisor doesn’t give generic answers. It analyzes your real revenue, expenses, and invoices to help you understand performance and decide with confidence.',
      benefits: [
        'Financial performance analysis',
        'Understand expenses and revenue',
        'Spot changes in your business',
        'Answer questions about your data',
        'Actionable insights for decisions',
        'Clearer view of business growth',
      ],
      cardTitle: 'AI Business Advisor',
      cardIntro: 'Based on your data, here are some insights:',
      insights: [
        'Sales this month are 32% higher',
        'Expenses increased by 12%',
        'Notable rise in one expense category',
      ],
      inputPlaceholder: 'Ask any question about your business...',
    },
    reports: {
      title: "Don't just collect numbers. Understand what they mean.",
      text: 'THI brings invoices, expenses, income, and reports together for a clearer picture of performance.',
      metrics: [
        'Total sales',
        'Total expenses',
        'Net performance',
        'Expenses by category',
        'Change vs previous period',
        'Business growth trend',
      ],
      supporting: 'Clearer data leads to better decisions.',
    },
    howItWorks: {
      title: 'Get started in 3 simple steps',
      steps: [
        {
          title: 'Create your account',
          desc: 'Sign up free in minutes with no hassle.',
        },
        {
          title: 'Add your business data',
          desc: 'Start with invoices, expenses, and business info.',
        },
        {
          title: 'Get clearer insights',
          desc: 'Use reports and the AI advisor to understand your business.',
        },
      ],
    },
    pricing: {
      title: 'Choose the right plan',
      subtitle: 'Flexible plans for every stage of growth.',
      compareTitle: 'Compare plans',
      compareSubtitle: 'Compare plans and pick what fits your business.',
      featureCol: 'Feature',
    },
    whyThi: {
      title: 'Why choose THI?',
      items: [
        { title: '3 languages', desc: 'Arabic, English, and Hebrew.' },
        {
          title: 'Expense scan & analysis',
          desc: 'Photograph a receipt and let AI read the data for you.',
        },
        {
          title: 'Invoice management',
          desc: 'Create and manage invoices from one place.',
        },
        {
          title: 'Reports that help you understand',
          desc: 'Turn business data into clear, usable insights.',
        },
        {
          title: 'AI business advisor',
          desc: 'A smart assistant powered by your THI data.',
        },
        {
          title: 'One platform for your business',
          desc: 'Invoices, expenses, reports, analytics, and AI together.',
        },
      ],
    },
    languages: {
      title: 'Use THI in your language',
      text: 'Switch language easily inside the app.',
      ar: { title: 'العربية', desc: 'Full Arabic interface, RTL' },
      en: { title: 'English', desc: 'Full English Interface' },
      he: { title: 'עברית', desc: 'Full Hebrew interface' },
    },
    faq: {
      title: 'Frequently asked questions',
      items: [
        {
          q: 'Do I need a credit card to start?',
          a: 'No. You can create an account and explore THI without a credit card.',
        },
        {
          q: 'Does THI support Arabic, English, and Hebrew?',
          a: 'Yes. THI is available in all three languages.',
        },
        {
          q: 'How does AI expense analysis work?',
          a: 'Photograph a receipt and the system reads and extracts key fields to help you record the expense quickly.',
        },
        {
          q: 'What is the smart business advisor?',
          a: 'An AI assistant that uses your THI data to help you understand expenses, revenue, and overall performance.',
        },
        {
          q: 'Can I change my plan later?',
          a: 'Yes. You can upgrade as your usage grows.',
        },
        {
          q: 'Can I manage more than one company?',
          a: 'The number of companies depends on your plan.',
        },
        {
          q: 'Are prices annual?',
          a: 'Yes. Prices shown are annual.',
        },
        {
          q: 'What are analysis tokens?',
          a: 'Credits used for AI-powered analysis features inside THI.',
        },
      ],
    },
    finalCta: {
      title: 'Understand your business better with THI today',
      text: 'Join THI and manage invoices, expenses, and business data in a simpler, smarter way.',
      cta: 'Start for Free Now',
      trust: 'Quick setup • No credit card • Arabic, English & Hebrew',
    },
    stickyCta: 'Start for Free',
  },
  he: {
    nav: {
      home: 'בית',
      features: 'תכונות',
      pricing: 'מחירים',
      about: 'אודות',
      contact: 'צור קשר',
    },
    hero: {
      label: 'פלטפורמה חכמה לניהול העסק',
      titleBefore: 'פלטפורמה אחת להבין ',
      titleHighlight: 'ולנהל את העסק שלך',
      subtitle:
        'כל מה שצריך לחשבוניות, הוצאות, דוחות והבנת ביצועים — עם בינה מלאכותית.',
      ctaPrimary: 'התחל בחינם',
      ctaSecondary: 'ראה איך THI עובד',
      trustNoCard: 'ללא כרטיס אשראי',
      trustQuick: 'התקנה מהירה',
      trustLang: 'עברית, אנגלית וערבית',
      aiAdvisorTitle: 'יועץ עסקים AI',
      aiAdvisorInsight: 'מכירות החודש גבוהות ב-32% מהחודש שעבר — המשך כך!',
      extractedTitle: 'הנתונים חולצו',
    },
    features: {
      title: 'כל כלי ניהול העסק במקום אחד',
      invoicing: 'חשבוניות',
      invoicingDesc: 'הפקה וניהול מקצועי של חשבוניות ומסמכים.',
      expenses: 'הוצאות',
      expensesDesc: 'הוסף וארגן הוצאות כדי להבין לאן הולך הכסף.',
      advisor: 'יועץ עסקים חכם',
      advisorDesc: 'עוזר AI שמבין את הנתונים ועוזר לקבל החלטות.',
      reports: 'דוחות וניתוח',
      reportsDesc: 'דוחות ברורים על בסיס נתונים אמיתיים.',
    },
    aiExpense: {
      title: 'הוספת הוצאות קלה יותר עם AI',
      text: 'צלם קבלה והמערכת תנתח ותחלץ את הנתונים אוטומטית.',
      steps: [
        'צלם את הקבלה',
        'THI קורא את הנתונים',
        'חילוץ פרטי ההוצאה',
        'סיווג ההוצאה',
        'הוספה לחשבונות',
      ],
      benefits: [
        'צילום כל חשבונית או קבלה',
        'חילוץ נתונים אוטומטי',
        'ניתוח AI',
        'סיווג אוטומטי',
        'פחות הקלדה ידנית',
        'חיסכון בזמן',
      ],
      cardTitle: 'הנתונים חולצו',
      amount: 'סכום',
      date: 'תאריך',
      category: 'קטגוריה',
      merchant: 'ספק',
      sampleAmount: '245.00',
      sampleDate: '15/04/2026',
      sampleCategory: 'מסעדות ומזון',
      sampleMerchant: 'שם החנות',
    },
    aiAdvisor: {
      label: 'THI AI',
      title: 'יועץ עסקים שמכיר את המספרים שלך',
      text: 'יועץ THI מנתח נתונים אמיתיים — הכנסות, הוצאות וחשבוניות — כדי לעזור לך להבין ולהחליט.',
      benefits: [
        'ניתוח ביצועים פיננסיים',
        'הבנת הוצאות והכנסות',
        'זיהוי שינויים בעסק',
        'מענה על שאלות על הנתונים',
        'תובנות לקבלת החלטות',
        'תמונה ברורה יותר של צמיחה',
      ],
      cardTitle: 'יועץ עסקים AI',
      cardIntro: 'על בסיס הנתונים שלך, הנה כמה תובנות:',
      insights: [
        'מכירות החודש גבוהות ב-32%',
        'הוצאות עלו ב-12%',
        'עלייה בולטת בקטגוריית הוצאות',
      ],
      inputPlaceholder: 'שאל כל שאלה על העסק שלך...',
    },
    reports: {
      title: 'לא רק לאסוף מספרים — להבין מה הם אומרים.',
      text: 'THI מרכז חשבוניות, הוצאות, הכנסות ודוחות לתמונה ברורה יותר.',
      metrics: [
        'סה״כ מכירות',
        'סה״כ הוצאות',
        'ביצוע נטו',
        'הוצאות לפי קטגוריה',
        'שינוי לעומת תקופה קודמת',
        'מגמת צמיחה',
      ],
      supporting: 'נתונים ברורים מובילים להחלטות טובות יותר.',
    },
    howItWorks: {
      title: 'התחל ב-3 שלבים פשוטים',
      steps: [
        { title: 'צור חשבון', desc: 'הירשם בחינם תוך דקות.' },
        { title: 'הוסף נתוני עסק', desc: 'התחל עם חשבוניות, הוצאות ופרטים.' },
        {
          title: 'קבל תובנות',
          desc: 'השתמש בדוחות וביועץ AI להבנה טובה יותר.',
        },
      ],
    },
    pricing: {
      title: 'בחר את החבילה המתאימה',
      subtitle: 'תוכניות גמישות לכל שלב צמיחה.',
      compareTitle: 'השוואת חבילות',
      compareSubtitle: 'השווה ובחר מה מתאים לעסק.',
      featureCol: 'תכונה',
    },
    whyThi: {
      title: 'למה THI?',
      items: [
        { title: '3 שפות', desc: 'ערבית, אנגלית ועברית.' },
        { title: 'סריקת הוצאות', desc: 'צלם קבלה ו-AI יקרא את הנתונים.' },
        { title: 'ניהול חשבוניות', desc: 'הכל במקום אחד.' },
        { title: 'דוחות להבנה', desc: 'נתונים ברורים לשימוש.' },
        { title: 'יועץ AI', desc: 'מבוסס על הנתונים שלך ב-THI.' },
        { title: 'פלטפורמה אחת', desc: 'חשבוניות, הוצאות, דוחות ו-AI.' },
      ],
    },
    languages: {
      title: 'השתמש ב-THI בשפה שלך',
      text: 'החלף שפה בקלות בתוך המערכת.',
      ar: { title: 'العربية', desc: 'ממשק מלא בערבית, RTL' },
      en: { title: 'English', desc: 'Full English Interface' },
      he: { title: 'עברית', desc: 'ממשק מלא בעברית' },
    },
    faq: {
      title: 'שאלות נפוצות',
      items: [
        {
          q: 'האם צריך כרטיס אשראי?',
          a: 'לא. אפשר להתחיל בלי כרטיס אשראי.',
        },
        {
          q: 'האם יש תמיכה בערבית, אנגלית ועברית?',
          a: 'כן. שלוש ממשקים מלאים.',
        },
        {
          q: 'איך עובד ניתוח הוצאות ב-AI?',
          a: 'צלם קבלה והמערכת תחלץ שדות חשובים.',
        },
        {
          q: 'מה זה יועץ העסקים?',
          a: 'עוזר AI שמשתמש בנתונים שלך ב-THI.',
        },
        { q: 'אפשר לשנות חבילה?', a: 'כן, לפי צמיחת השימוש.' },
        {
          q: 'יותר מחברה אחת?',
          a: 'תלוי בחבילה שבחרת.',
        },
        { q: 'המחירים שנתיים?', a: 'כן.' },
        { q: 'מה זה טוקני ניתוח?', a: 'קרדיט לפיצ\'רי AI ב-THI.' },
      ],
    },
    finalCta: {
      title: 'התחל להבין את העסק שלך עם THI',
      text: 'נהל חשבוניות, הוצאות ונתונים בצורה פשוטה וחכמה.',
      cta: 'התחל בחינם עכשיו',
      trust: 'התקנה מהירה • ללא כרטיס • עברית, אנגלית וערבית',
    },
    stickyCta: 'התחל בחינם',
  },
};

export function getCampaignT(lang: Language): CampaignTranslations {
  return campaignTranslations[lang] ?? campaignTranslations.ar;
}
